import { NgOptimizedImage } from "@angular/common";
import { Component, computed, inject } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { LanguageService } from "../../../services";
import { ThemeService } from "../../../services/theme-service";
import { SpinnerComponent } from "../../spinner/spinner";

@Component({
  selector: "adaa-auth-layout",
  templateUrl: "./auth-layout.html",
  styleUrl: "./auth-layout.scss",
  imports: [NgOptimizedImage, TranslatePipe, SpinnerComponent],
})
export class AuthLayoutComponent {
  languageService = inject(LanguageService);
  themeService = inject(ThemeService);

  themeTarget = computed(() => (this.themeService.resolved() === "dark" ? "light" : "dark"));
}
